<template>
	<div class="about-upgrades">
		<p>{{ translate("ui.upgrade_info_1") }}</p>
		<p>{{ translate("ui.upgrade_info_2") }}</p>
	</div>
</template>

<script lang="ts" setup>
import { translate } from "@/utils/translate";
</script>

<style lang="scss" scoped>
.about-upgrades {
	@include flex-col-center;
	flex: 1 1 0;
	color: #372615;
	font-size: 0.875rem;
	line-height: 1rem;
	text-align: center;
}
</style>
